import {courseService} from '@jobseeker/common-core/services';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Typography} from '@mui/material';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';

type Banner = {
  bannerPath: string;
  bannerPathResponsive: string;
  bannerPathSmall: string;
  bannerName: string;
  bannerText: string;
  bannerLogo: string;
  bannerUrl: string;
};

const Banner = () => {
  const [bannerData, setBannerData] = useState<Banner>();

  useEffect(() => {
    courseService.getBanner().then((data: Banner) => setBannerData(data));
  }, []);

  const isDeviceLarge = useIsLargeDevice();

  if (!bannerData) {
    return;
  }

  const {
    bannerPath,
    bannerUrl,
    bannerText,
    bannerLogo,
    bannerName,
    bannerPathResponsive,
    bannerPathSmall,
  } = bannerData;

  return (
    <Box
      sx={{
        background: `image-set(url('${bannerPath}') 1x, url('${bannerPathResponsive}') 2x, url('${bannerPathSmall}') 3x) 0% 0% / cover no-repeat`,
        ':hover': {
          cursor: 'pointer',
        },
      }}
      height={520}
      pt={isDeviceLarge ? 14 : 8}
      pl={isDeviceLarge ? 14 : 3}
      display="flex"
      justifyContent="space-between"
      flexDirection={isDeviceLarge ? 'row' : 'column'}
      onClick={() => openUrl(bannerUrl, '_blank')}
      className="banner-container"
    >
      <Typography
        component="h1"
        className="main-heading"
        fontWeight={600}
        color="white"
        fontSize={isDeviceLarge ? 40 : 30}
        maxWidth={792}
        mt={2}
        sx={{
          textShadow: 'rgb(16, 16, 16) 1px 1px 1px',
        }}
      >
        {bannerText}
      </Typography>
      <Box
        display="flex"
        flexDirection={isDeviceLarge ? 'column' : 'row'}
        sx={{
          ...(!isDeviceLarge && {
            justifyContent: 'space-between',
            width: '100%',
          }),
        }}
      >
        <Image
          src={bannerLogo}
          height={isDeviceLarge ? 150 : 120}
          width={isDeviceLarge ? 150 : 120}
          alt="institute-logo"
          style={{alignSelf: isDeviceLarge ? 'end' : 'start'}}
        />
        <Typography
          bgcolor="rgba(0, 0, 0, 0.52)"
          py={1}
          px={2}
          maxWidth={187}
          height="fit-content"
          borderRadius="25px 0 0 25px"
          color="white"
          fontSize={12}
          fontWeight={600}
        >
          {bannerName}
        </Typography>
      </Box>
    </Box>
  );
};

export default Banner;
